import OnboardingBeacons from 'growth-onboarding-beacon/OnboardingBeacons';
import { useMemo } from 'react';
import { useIsEligibleForHC0133 } from 'trial-components-library/utils/trialStateUtils';
import { getQueryStringParameter } from 'growth-payments-core/query-string/utils';
import { useScopes } from '../../auth/hooks/useScopes';
import { useIsHc0133Variant } from '../../experiments/hooks/useIsHc0133Variant';
import { useModalActions } from '../../overlay/hooks/useModalActions';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingBeaconWrapper = () => {
  const {
    openContactDataImportModal
  } = useModalActions();
  const userScopes = useScopes();
  const {
    isInVariant
  } = useIsHc0133Variant();
  const scopes = useMemo(() => {
    return Object.keys(userScopes);
  }, [userScopes]);
  const {
    isEligible: isEligibleForHC0133
  } = useIsEligibleForHC0133({
    scopes
  });
  const shouldUseSampleDataOnboardingConfig = isEligibleForHC0133 && isInVariant;
  const shouldUseGeneratedViewOnboardingConfig = getQueryStringParameter('taskKey') === 'set-up-data-model';
  if (shouldUseGeneratedViewOnboardingConfig && !shouldUseSampleDataOnboardingConfig) {
    return /*#__PURE__*/_jsx(OnboardingBeacons, {
      beaconsConfigId: "generated-view-index-contacts",
      callbacks: {
        openContactDataImportModal
      }
    });
  }
  if (shouldUseSampleDataOnboardingConfig) {
    return /*#__PURE__*/_jsx(OnboardingBeacons, {
      beaconsConfigId: "sample-data-contacts"
    });
  }
  return /*#__PURE__*/_jsx(OnboardingBeacons, {
    beaconsConfigId: "crm-index-contacts",
    callbacks: {
      openContactDataImportModal
    }
  });
};
export default OnboardingBeaconWrapper;